<div class="zoom-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt: find this number -->
  <div class="prompt-bar">
    <span class="prompt-text">{{ currLang === 'ar' ? 'كبّر للوصول إلى' : 'Zoom in to find' }}</span>
    <span class="target">
      <ng-container *ngFor="let cell of digitCells">
        <span *ngIf="cell.comma" class="comma">,</span>
        <span *ngIf="!cell.comma" class="digit"
              [class.active]="isActiveCell(cell)" [class.locked]="isLockedCell(cell)">{{ cell.char }}</span>
      </ng-container>
    </span>
    <span class="place-hint">{{ (currLang === 'ar' ? 'اختر خانة ' : 'placing the ') + activePlaceName }}</span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-zoom-quest-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-zoom-quest-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn zoom-out-btn" [disabled]="resolving || !stage?.canZoomOut" (click)="onZoomOut()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2.2"/>
        <path d="M8 11h6M16 16l5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
      {{ currLang === 'ar' ? 'تصغير' : 'Zoom Out' }}
    </button>

    <button *ngIf="!stage?.atFinest" class="ctrl-btn zoom-in-btn"
            [disabled]="resolving || !stage?.canZoomIn" (click)="onZoomIn()">
      {{ currLang === 'ar' ? 'تكبير' : 'Zoom In' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2.2"/>
        <path d="M11 8v6M8 11h6M16 16l5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
    </button>

    <button *ngIf="stage?.atFinest" class="ctrl-btn plant-btn"
            [disabled]="resolving || !stage?.canPlant" (click)="onPlant()">
      {{ currLang === 'ar' ? 'احفر هنا!' : 'Dig here!' }}
      <span aria-hidden="true">⛏️</span>
    </button>

    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">💎</span>
      <span class="success-eq">{{ (currLang === 'ar' ? 'وجدت ' : 'Found ') + round.target.toLocaleString('en-US') + '!' }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
